<div>
  <!--Users-->
  <div class="row-no-margin">
    <div class="col-md-3 search-box">
      <input type="text"
             [(ngModel)]="NameFilter.Value"
             placeholder="User Name"
             matInput
             (blur)="checkUserFilterInput($event)"
             (keyup.enter)="LoadUsers(false)">
             <!--[formControl]="userSearchControl"-->
             <!--[matAutocomplete]="userNameAuto"-->
             
      <!--<mat-autocomplete autoActiveFirstOption #userNameAuto="matAutocomplete" [displayWith]="userDisplayFn" (optionSelected)="userAutoComplete_Selected($event)">
        <mat-option *ngFor="let option of filteredUsers | async" [value]="option.Name">
          {{option.Name}}({{option.OwnerEmail}})
        </mat-option>
      </mat-autocomplete>-->
     
    </div>
   
    
    <div class="col-md-2" style="padding-left:50px;">
      <button class="blue" (click)="CreateNewUser()">Create New</button>
    </div>
  </div>
  <div class="row-no-margin">
    <div *ngIf="CurrentUser.IsTolomaticUser" class="col-md-3">
      <mat-form-field  appearance="fill">
        <mat-label>Distributor:</mat-label>
        <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [value]="CurrentDist">
          <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
            {{dist.Company}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field appearance="fill">
        <mat-label>User Role</mat-label>
        <mat-select (selectionChange)="RoleChange($event)" [(ngModel)]="RoleFilter.Value">
          <mat-option *ngIf="CurrentUser.IsTolomaticUser" value="all">
            All Roles
          </mat-option>
          <mat-option *ngIf="CurrentUser.IsTolomaticUser" value="administrator">
            Administrator
          </mat-option>
          <mat-option value="distributor-manager">
            Distributor Manager
          </mat-option>
          <mat-option value="distributor">
            Distributor
          </mat-option>
          <!--<mat-option value="user">
            User
          </mat-option>
          <mat-option value="inactive">
            Inactive
          </mat-option>-->
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-5">
      <mat-paginator [length]="UserListCount"
                     [pageSize]="UserListPageSize"
                     [pageSizeOptions]="PageSizeOptions"
                     (page)="UserListPageEvent($event)"></mat-paginator>
    </div>
    <div class="col-md-2"></div>
  </div>

  <div class="col-md-12">
    <table style="width:95%;" class="userTable">
      <tr>
        <th style="width:20%;text-align:center;">User</th>
        <th style="width: 20%; text-align: center;">Email Address</th>
        <th style="width: 10%; text-align: center;">City</th>
        <th style="width: 10%; text-align: center;">State</th>
        <th style="width: 10%; text-align: center;">Zip Code</th>
        <th style="width: 10%; text-align: center;">Role</th>
        <th style="width: 10%; text-align: center;">Distributor</th>
        <th style="width: 10%; text-align: center;"></th>
      </tr>
      <ng-container *ngFor="let user of UserList | UserFilter:NameFilter.Value">
        <tr>
          <td>{{user.LastName}}, {{user.FirstName}} </td>
          <td>{{user.Email}}</td>
          <td style="text-align: center;">{{user.City}}</td>
          <td style="text-align: center;">{{user.State}}</td>
          <td style="text-align: center;">{{user.ZipCode}}</td>
          <td style="text-align: center;">{{user.Role}}</td>
          <td>{{user.Distributor && user.Distributor.Company ?? user.Distributor.Company}}</td>
          <td>
            <mat-select placeholder="Options" (selectionChange)="Option_Change($event,user)">
              <mat-option value="edit">
                Edit
              </mat-option>
              <mat-option value="resetpassword">
                Reset Password
              </mat-option>

              <mat-option [ngStyle]="{ display : user.Role == 'inactive' ? 'block' : 'none'}" value="resendverification">
                Resend Verification
              </mat-option>

            </mat-select>


          </td>
        </tr>
      </ng-container>

    </table>
  </div>
</div>
